import type {RouteLocationNormalizedGeneric} from 'vue-router';
import useFeatures from '@/composables/useFeatures';
import {redirectToMeteor} from '@/router/redirectToMeteor';

export const featureToggleGuard = (to: RouteLocationNormalizedGeneric) => {
  const {isFeatureActive} = useFeatures();
  if (!to?.meta?.feature) {
    return true;
  }

  if (isFeatureActive(to.meta.feature)) {
    return true;
  }

  return redirectToMeteor(to);
};
